/**
 * 表单验证工具类
 */
export const validatePhoneEmail = (rule, value, callback) => {
  if (!value) callback(new Error('请输入手机号或者邮箱'))
  else {
    if (value != '') {
      if (value.indexOf('@') != -1) {
        if (
          !/^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/.test(
            value
          )
        )
          callback(new Error('请输入正确的邮箱'))
      } else {
        if (!/^1[3456789]\d{9}$/.test(value))
          callback(new Error('请输入正确的手机号'))
      }
      callback()
    }
  }
}

export const validatePhone = (rule, value, callback) => {
  console.log(rule, value)
  if (!value) callback(new Error('请输入手机号'))
  else {
    if (value) {
      if (!/^1[3456789]\d{9}$/.test(value))
        callback(new Error('请输入正确的手机号'))
      callback()
    }
  }
}

export const validatePwd = (rule, value, callback) => {
  if (!value) {
    callback(new Error('请输入密码'))
  } else {
    if (value) {
      if (value.length < 6)
        callback(new Error('请输入6~16位字符的密码'))
    }
    callback()
  }
}

export const validateCode = (rule, value, callback) => {
  if (!value) {
    callback(new Error('请输入验证码'))
  } else {
    if (value) {
      if (!/^[0-9]*$/.test(value))
        callback(new Error('请输入正确的验证码'))
    }
    callback()
  }
}
